import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'image-signup',
  templateUrl: './image-signup.component.html',
  styleUrls: []
})
export class ImageSignupComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
